class PdpQuoteCarousel extends HTMLElement {
  constructor() {
    super();

    window.loadSwiper.then(({ Swiper, Pagination }) => {
      const swiperParams = {
        modules: [Pagination],
        slidesPerView: "auto",
        navigation: {
          nextEl: this.querySelector(
            "[data-pdp-quote-carousel-navigation-next]",
          ),
          prevEl: this.querySelector(
            "[data-pdp-quote-carousel-navigation-previous]",
          ),
        },
        pagination: {
          clickable: true,
          enabled: true,
          el: ".swiper-pagination",
        },
        centerInsufficientSlides: true,
        // breakpoints: {
        //   768: {
        //     pagination: {
        //       enabled: false,
        //     },
        //   },
        //   1024: {
        //     pagination: {
        //       enabled: false,
        //     },
        //   },
        //   1440: {
        //     pagination: {
        //       enabled: false,
        //     },
        //   },
        // },
        on: {
          lock: () => {
            this.classList.add("pdp-quote-carousel__carousel-wrapper--locked");
          },
          unlock: () => {
            this.classList.remove(
              "pdp-quote-carousel__carousel-wrapper--locked",
            );
          },
        },
      };

      this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);
    });
  }

  connectedCallback() {}

  disconnectedCallback() {}
}

if (!customElements.get("pdp-quote-carousel")) {
  customElements.define("pdp-quote-carousel", PdpQuoteCarousel);
}
